import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { ResourceHub, collectionPageJsonLd } from "@/components/site/ResourceHub";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { loadPublicResourcesForHub } from "@/lib/query-registry";
import { SITE_URL } from "@/lib/i18n";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/recursos/seo-tecnico";
const ALT = "/resources/technical-seo";
const DESC = "Guías de SEO técnico para Shopify sobre crawling, indexación, canonicals, datos estructurados, arquitectura, rendering y riesgo de migración.";

export const Route = createFileRoute("/es/recursos/seo-tecnico")({
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    return loadPublicResourcesForHub(context.queryClient);
  },
  head: ({ loaderData }) => {
    const resources = (loaderData as any)?.resources ?? [];
    const urls = resources
      .filter((resource: any) => resource.cluster === "technical-seo" || /technical seo|seo técnico|seo|crawl|index|canonical|schema|hreflang|rendering/i.test([resource.slug, resource.slug_es, resource.title_es, ...(resource.tags_es ?? [])].join(" ")))
      .map((resource: any) => `${SITE_URL}/es/recursos/${resource.slug_es ?? resource.slug}`);
    return buildHead({
      locale: "es", title: "Recursos y guías de SEO Técnico para Shopify · Shugert", description: DESC,
      path: PATH, altPath: ALT,
      jsonLd: [
        breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Recursos", path: "/es/recursos" }, { name: "SEO Técnico", path: PATH }]),
        collectionPageJsonLd("Recursos de SEO Técnico para Shopify", `${SITE_URL}${PATH}`, DESC, urls),
      ],
    });
  },
  component: () => (
    <SiteShell>
      <ResourceHub locale="es" cluster="technical-seo" copy={{
        eyebrow: "Recursos de SEO Técnico",
        title: "Recursos de SEO técnico para tiendas Shopify que deben ser entendidas correctamente.",
        intro: "Guías de crawling, indexación, canonicals, schema, rendering, arquitectura y continuidad SEO en migraciones, separadas de CRO.",
        serviceLabel: "Ver SEO Técnico para Shopify", serviceHref: "/es/seo-tecnico-shopify",
        articlesTitle: "Guías de SEO Técnico", articlesEmpty: "Próximamente publicaremos más guías de SEO técnico.",
        read: "Leer", min: "min", by: "Por", updated: "Actualizado", backLabel: "Recursos", backHref: "/es/recursos",
      }} />
    </SiteShell>
  ),
});
